import React from "react";
import FleecejackePrimo from "../Garments/FleecejackePrimo";

export default function FleecejackePrimoPage() {
  return <FleecejackePrimo />;
}
